import { provideZoneChangeDetection } from "@angular/core";
import { platformBrowser } from "@angular/platform-browser";

import { AppModule } from "./app/app.module";
import { provideVersionLog } from "./app/core/app-version";
import { APP_VERSION_INFO, THIRD_PARTY_LICENSES } from "core-client/api";
import { APP_VERSION } from "./environments/version";
import { THIRD_PARTY_LICENSES_DATA } from "./app/core/third-party-licenses.generated";

// platformBrowser, not platformBrowserDynamic: the latter is deprecated and only ever
// existed to ship the JIT compiler, which neither build needs -- both are AOT. Still
// bootstrapModule and not bootstrapApplication, because the app root is an NgModule.
platformBrowser()
  .bootstrapModule(AppModule, {
    applicationProviders: [
      provideZoneChangeDetection({ eventCoalescing: true }),
      provideVersionLog(),
      { provide: APP_VERSION_INFO, useValue: APP_VERSION },
      { provide: THIRD_PARTY_LICENSES, useValue: THIRD_PARTY_LICENSES_DATA },
    ],
  })
  .catch((err) => console.error(err));
